import React from 'react';

const RecentDocuments = ({ documents, selectedDocument, onDocumentSelect }) => {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getEntityCount = (entities) => {
        if (!entities) return 0;
        return Object.keys(entities).reduce((total, key) => {
            return total + (Array.isArray(entities[key]) ? entities[key].length : 0);
        }, 0);
    };

    const truncateFilename = (filename, maxLength = 25) => {
        if (filename.length <= maxLength) return filename;
        const extension = filename.split('.').pop();
        const nameWithoutExt = filename.substring(0, filename.lastIndexOf('.'));
        const truncated = nameWithoutExt.substring(0, maxLength - extension.length - 4) + '...';
        return `${truncated}.${extension}`;
    };

    return (
        <div className="card">
            <div className="card-header">
                <h6 className="mb-0">
                    <i className="fas fa-history me-2"></i>
                    Recent Documents
                </h6>
            </div>
            <div className="card-body p-0">
                {documents.length === 0 ? (
                    <div className="text-center py-3">
                        <i className="fas fa-file-alt fa-2x text-muted mb-2"></i>
                        <p className="text-muted small mb-0">No documents processed yet</p>
                    </div>
                ) : (
                    <div className="list-group list-group-flush">
                        {documents.map((doc) => (
                            <button
                                key={doc.id}
                                className={`list-group-item list-group-item-action border-0 ${
                                    selectedDocument?.id === doc.id ? 'active' : ''
                                }`}
                                onClick={() => onDocumentSelect(doc)}
                                style={{ fontSize: '0.875rem' }}
                            >
                                <div className="d-flex justify-content-between align-items-start">
                                    <div className="flex-grow-1">
                                        <div className="fw-bold mb-1" title={doc.filename}>
                                            <i className="fas fa-file-alt me-2"></i>
                                            {truncateFilename(doc.filename)}
                                        </div>
                                        <div className="small text-muted mb-1">
                                            {getEntityCount(doc.entities)} entities
                                        </div>
                                        <div className="small text-muted">
                                            {formatDate(doc.processedAt)}
                                        </div>
                                    </div>
                                    {selectedDocument?.id === doc.id && (
                                        <i className="fas fa-check-circle text-success"></i>
                                    )}
                                </div>
                                
                                {/* Entity preview */}
                                {doc.entities && Object.keys(doc.entities).length > 0 && (
                                    <div className="mt-2">
                                        <div className="d-flex flex-wrap gap-1">
                                            {Object.entries(doc.entities)
                                                .filter(([_, items]) => Array.isArray(items) && items.length > 0)
                                                .slice(0, 3)
                                                .map(([category, items]) => (
                                                    <span
                                                        key={category}
                                                        className="badge bg-secondary"
                                                        style={{ fontSize: '0.7rem' }}
                                                    >
                                                        {category}: {items.length}
                                                    </span>
                                                ))
                                            }
                                            {Object.keys(doc.entities).length > 3 && (
                                                <span
                                                    className="badge bg-light text-dark"
                                                    style={{ fontSize: '0.7rem' }}
                                                >
                                                    +{Object.keys(doc.entities).length - 3} more
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </button>
                        ))}
                    </div>
                )}
            </div>
            
            {documents.length > 0 && (
                <div className="card-footer">
                    <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Click a document to view its analysis
                    </small>
                </div>
            )}
        </div>
    );
};

export default RecentDocuments;
